import fetch from '../utils/fetch';

//删除公式配置
export function deleteFormulaConf(params) {
  return fetch({
    method:'POST',
    url:'formulaConf/deleteFormulaConf',
    data:params
  })
}

//分页查询
export function formulaConfListByPage(params) {
  return fetch({
    method:'GET',
    url:'formulaConf/formulaConfListByPage',
    params
  })
}

//启用或停用
export function enableOrNot(params){
  return fetch({
    method:'POST',
    url:'formulaConf/enableOrNot',
    data:params
  })
}

//获取下拉列表数据
export function queryData(params){
  return fetch({
    method:'GET',
    url:'formulaConf/queryData',
    params
  })
}

//保存公式配置
export function saveFormulaConf(params){
  return fetch({
    method:'POST',
    url:'formulaConf/saveFormulaConf',
    data:params
  })
}

//获取全部业绩公式
export function allFormula(params){
  return fetch({
    method:'GET',
    url:'formula/allFormula',
    params
  })
}
